export const DentureItemOrderTypeEnum = {
  WAX_BITE: "WAX_BITE",
  TRY_IN: "TRY_IN",
  FINAL: "FINAL",
} as const;

export type DentureItemOrderType =
  (typeof DentureItemOrderTypeEnum)[keyof typeof DentureItemOrderTypeEnum];
